import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Waypoint from 'react-waypoint';
import lodashThrottle from 'lodash/throttle';
import EventListener from 'fbjs/lib/EventListener';
import domHelperHeight from 'dom-helpers/query/height';

import './FixedWrapper.css';

class FixedWrapper extends React.Component {

  static propTypes = {
    height: PropTypes.number.isRequired,
    points: PropTypes.arrayOf(PropTypes.string.isRequired),
    onPointPosition: PropTypes.func
  };

  static defaultProps = {
    points: []
  };

  state = {
    position: 'before',
    beforeDisplay: 'none',
    afterDisplay: 'block',
    height: domHelperHeight(window)
  };

  render() {
    return (
      <div className={classnames('FixedWrapper', this.props.className)}>
        <Waypoint
          onPositionChange={this._onPositionBefore.bind(this)}
        />
        {
          this.props.points.map((point, idx) => (
            <Waypoint
              key={idx}
              bottomOffset={point}
              onPositionChange={this._onPointPositionChange.bind(this, idx)}
            />
          ))
        }
        <div
          className="FixedWrapper-spaceBefore"
          style={{
            display: this.state.beforeDisplay,
            height: `${this.props.height + (this.state.position === 'enter' ? this.state.height : 0)}px`
          }}
        />
        <div 
          className={classnames('FixedWrapper-fixedContainer', {
            fixed: this.state.position === 'enter'
          })}
          ref={(input) => { this._fixedContainer = input; }}>
          {this.props.children}
        </div>
        <div
          className="FixedWrapper-spaceAfter"
          style={{
            display: this.state.afterDisplay,
            height: `${this.props.height + (this.state.position === 'enter' ? this.state.height : 0)}px`
          }}
        />
        <Waypoint
          onPositionChange={this._onPositionAfter.bind(this)}
        />
      </div>
    );
  }

  componentDidMount() {
    this._attachScrollListener();
  }

  componentWillUnmount() {
    this._detachScrollListener();
  }

  _attachScrollListener = () => {
    this._resizeListener = EventListener.listen(window, 'resize', lodashThrottle(this._onResize, 50));
    this._onResize();
  };

  _detachScrollListener = () => {
    if (this._resizeListener) {
      this._resizeListener.remove();
      this._resizeListener = null;
    }
  };

  _onResize = () => {
    this.setState({
      height: domHelperHeight(window)
    });
  };

  _onPositionBefore = ({ previousPosition, currentPosition }) => {
    if (previousPosition === 'inside' && currentPosition === 'above') {
      this.setState({
        position: 'enter',
        beforeDisplay: 'none',
        afterDisplay: 'block'
      });
    } else if (previousPosition === 'above' && currentPosition === 'inside') {
      this.setState({
        position: 'before',
        beforeDisplay: 'none',
        afterDisplay: 'block'
      });
    } else if (previousPosition === 'inside' && currentPosition === 'below') {
      this.setState({
        position: 'before',
        beforeDisplay: 'none',
        afterDisplay: 'block'
      });
    } else if (previousPosition === 'below' && currentPosition === 'inside') {
      this.setState({
        position: 'before',
        beforeDisplay: 'none',
        afterDisplay: 'block'
      });
    } else {
      this._initialBeforePosition = currentPosition;
    }
  };

  _onPositionAfter = ({ previousPosition, currentPosition }) => {
    if (previousPosition === 'below' && currentPosition === 'inside') {
      this.setState({
        position: 'after',
        beforeDisplay: 'block',
        afterDisplay: 'none'
      });
    } else if (previousPosition === 'inside' && currentPosition === 'below') {
      this.setState({
        position: 'enter',
        beforeDisplay: 'block',
        afterDisplay: 'none'
      });
    } else {
      if (this._initialBeforePosition === 'above' && currentPosition === 'inside') {
        this.setState({
          position: 'after',
          beforeDisplay: 'block',
          afterDisplay: 'none'
        });
      } else if (this._initialBeforePosition === 'above' && currentPosition === 'below') {
        this.setState({
          position: 'enter',
          beforeDisplay: 'block',
          afterDisplay: 'none'
        });
      }
    }
  };

  _onPointPositionChange = (idx, { previousPosition, currentPosition }) => {
    this.props.onPointPosition(idx, currentPosition);
  };

}

export default FixedWrapper;



// WEBPACK FOOTER //
// ./src/components/FixedWrapper.js